import {
  getTierSeatsLeft,
  isTierUnavailable,
} from '@shared/restaurantEvents/tierAvailability';
import type {
  BookingUnit,
  RestaurantEventTier,
} from '@shared/types/restaurants';
import { getBookingUnitLabels } from '@shared/restaurantEvents/bookingUnitLabels';
import { LOW_INVENTORY_MAX_SPOTS } from '../constants';

/**
 * The capacity predicates live in `@shared/restaurantEvents/tierAvailability`
 * so the restaurant admin applies the same sold-out rules. They are re-exported
 * here for the customer flow, which also owns the low-inventory copy below.
 */
export {
  areAllTiersUnavailable,
  getEventSpotsLeft,
  getTierMaxQuantity,
  getTierMaxTicketsPerPurchase,
  getTierSeatsLeft,
  getTierSpotsLeft,
  isEventSoldOut,
  isTierAtCapacityForGuestCount,
  isTierSoldOut,
  isTierUnavailable,
} from '@shared/restaurantEvents/tierAvailability';

export const shouldShowLowInventoryBadge = (
  tier: Pick<RestaurantEventTier, 'ticketsSold' | 'capacity'>,
  tiers: Pick<RestaurantEventTier, 'ticketsSold'>[],
  eventCapacity: number,
  allowedQuantities?: number[] | null,
): boolean => {
  if (isTierUnavailable(tier, tiers, eventCapacity)) {
    return false;
  }
  const seatsLeft = getTierSeatsLeft(tier, allowedQuantities);
  return seatsLeft >= 1 && seatsLeft <= LOW_INVENTORY_MAX_SPOTS;
};

export const getSeatsLeftLabel = (
  spotsLeft: number,
  bookingUnit: BookingUnit,
): string => {
  const { unitLabel, unitLabelPlural } = getBookingUnitLabels(bookingUnit);
  return `Only ${spotsLeft} ${spotsLeft === 1 ? unitLabel : unitLabelPlural} left!`;
};
